module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-dropdown-move-left-07105ec7c128d6bffcc85c573cd159df.svg";